import { IconProps } from "./icon.type";

export function IcSidebarAccountManagementActive({ ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7871 18C19.3394 18 19.7871 18.4477 19.7871 19C19.7871 19.5523 19.3394 20 18.7871 20H12.001C11.4487 20 11.001 19.5523 11.001 19C11.001 18.4477 11.4487 18 12.001 18H18.7871ZM9.69727 0C12.4594 0.000174917 14.6982 2.2387 14.6982 5C14.6982 7.7613 12.4594 9.99983 9.69727 10C9.67944 10 9.66133 9.99823 9.64355 9.99805V10C7.2199 10.0001 5.40004 10.9882 4.16406 12.5459C2.90874 14.1284 2.21289 16.3588 2.21289 18.8564C2.21266 19.4085 1.76503 19.8564 1.21289 19.8564C0.660838 19.8563 0.213119 19.4085 0.212891 18.8564C0.212891 16.0115 1.00265 13.3133 2.59668 11.3037C3.54798 10.1046 4.77237 9.17365 6.23828 8.60938C5.28815 7.69926 4.69531 6.41934 4.69531 5C4.69531 2.23859 6.93496 0 9.69727 0ZM18.7871 14.5C19.3394 14.5 19.7871 14.9477 19.7871 15.5C19.7871 16.0523 19.3394 16.5 18.7871 16.5H12.001C11.4487 16.5 11.001 16.0523 11.001 15.5C11.001 14.9477 11.4487 14.5 12.001 14.5H18.7871ZM18.7871 11C19.3394 11 19.7871 11.4477 19.7871 12C19.7871 12.5523 19.3394 13 18.7871 13H12.001C11.4487 13 11.001 12.5523 11.001 12C11.001 11.4477 11.4487 11 12.001 11H18.7871Z"
        fill="#00152C"
      />
    </svg>
  );
}
